import React from 'react';
import {
    CHOCOLATE_CAROUSEL_TYPE,
    CHOCOLATE_GRID_TYPE,
    GIGS_CAROUSEL_TYPE,
    GIGS_LISTING_TYPE,
    GIGS_VIEW_LISTING_TYPE,
    PRO_GIGS_CAROUSEL_TYPE,
    PRO_GIGS_VIEW_LISTING_TYPE,
    RECENTLY_VIEWED_TYPE,
    SMALL_GIGS_LIST_VIEW_TYPE,
    DYNAMIC_CAROUSEL_TYPE,
    CHOICE_NESTED_TABS,
    BRICKS_LIST_TYPE,
    TRANSPARENT_CAROUSEL_TYPE,
    SELLERS_SLIDING_CAROUSEL_TYPE,
    SELLERS_GRID_VIEW_TYPE,
    SELLER_ROLES_SLIDING_CAROUSEL_TYPE,
    SELLERS_SLIDING_JP_TYPE,
    SELECTABLE_SELLERS_COLUMN_VIEW_TYPE,
    SELLERS_JP_ADAPTIVE_SLIDING_CAROUSEL_TYPE,
} from '../../utils/constants';
import { componentMapperPropTypes, PersonalizedComponentMapperCommon } from './common';

import './style.scss';

export const PERSONALIZED_COMPONENTS = {
    [GIGS_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'GigCardCarouselWrapper' */ '../gigs/GigCardCarouselWrapper'),
    [PRO_GIGS_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'GigCardCarouselWrapper' */ '../gigs/GigCardCarouselWrapper'),
    [GIGS_LISTING_TYPE]: () =>
        import(/* webpackChunkName: 'GigCardListingsWrapper' */ '../gigs/GigCardListingsWrapper'),
    [GIGS_VIEW_LISTING_TYPE]: () => import(/* webpackChunkName: 'GigsListViewWrapper' */ '../gigs/GigsListViewWrapper'),
    [SMALL_GIGS_LIST_VIEW_TYPE]: () =>
        import(/* webpackChunkName: 'SmallListViewListingWrapper' */ '../gigs/SmallListViewListingWrapper'),
    [RECENTLY_VIEWED_TYPE]: () =>
        import(/* webpackChunkName: 'RecentlyViewedCarousel' */ '../gigs/RecentlyViewedCarousel'),
    [PRO_GIGS_VIEW_LISTING_TYPE]: () =>
        import(/* webpackChunkName: 'GigsListViewWrapper' */ '../gigs/GigsListViewWrapper'),
    [CHOCOLATE_GRID_TYPE]: () => import(/* webpackChunkName: 'ChocolateGridWrapper' */ '../gigs/ChocolateGridWrapper'),
    [CHOCOLATE_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'ChocolateCarouselWrapper' */ '../gigs/ChocolateCarouselWrapper'),
    [BRICKS_LIST_TYPE]: () => import(/* webpackChunkName: 'BricksListWrapper' */ '../gigs/BricksListWrapper'),
    [DYNAMIC_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'DynamicGigCardCarouselWrapper' */ '../gigs/DynamicGigCardCarouselWrapper'),
    [CHOICE_NESTED_TABS]: () => import(/* webpackChunkName: 'MultiTabs' */ '../MultiTabs'),
    [TRANSPARENT_CAROUSEL_TYPE]: () => import(/* webpackChunkName: 'TransparentComponent' */ '../TransparentComponent'),
    [SELLERS_SLIDING_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'SellersSlidingCarousel' */ '../sellers/SellersSlidingCarousel'),
    [SELLERS_GRID_VIEW_TYPE]: () => import(/* webpackChunkName: 'SellersGridView' */ '../sellers/SellersGridView'),
    [SELLER_ROLES_SLIDING_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'RolesCarousel' */ '../RolesCarousel/RolesCarousel'),
    [SELLERS_SLIDING_JP_TYPE]: () =>
        import(/* webpackChunkName: 'SellersSlidingJPCarousel' */ '../sellers/JPSlidingCarousel'),
    [SELECTABLE_SELLERS_COLUMN_VIEW_TYPE]: () =>
        import(/* webpackChunkName: 'SelectableSellersColumnView' */ '../sellers/SelectableSellersColumnView'),
    [SELLERS_JP_ADAPTIVE_SLIDING_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'JPAdaptiveCarousel' */ '../sellers/JPAdaptiveCarousel'),
};

export const PersonalizedComponentMapper = (props) => {
    const { type } = props.component;

    const PersonalizedComponent = PERSONALIZED_COMPONENTS[type];

    return (
        <PersonalizedComponentMapperCommon
            {...props}
            PersonalizedComponent={PersonalizedComponent}
            PersonalizedComponentMapper={PersonalizedComponentMapper}
            shouldLazyImport
        />
    );
};

PersonalizedComponentMapper.propTypes = componentMapperPropTypes;
